export const handleOnCollapse = (onCollapse: () => void) => {
  if (onCollapse) {
    onCollapse();
  }
};

export default {
  handleOnCollapse
};
